import React from "react";
import {
  Button,
  Stack,
  Checkbox,
  Collapse,
  useTheme,
} from "@mui/material";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import { GradientBorderBox } from "../../../../../Components";

export default function CatItems({
  data,
  catsOpen,
  setCatsOpen,
  handleQuery,
  query,
}) {
  const theme = useTheme();

  const items = data?.data?.tree?.map((mainCat, mainCatIndex) => {
    const isMainOpen = catsOpen?.mainCategories === mainCat?.code;

    const subItems = mainCat?.children?.map((subCat, subCatIndex) => {
      const isSubOpen = catsOpen?.subCategories === subCat?.code;

      const subSubItems = subCat?.children?.map((subSubCat, subSubCatIndex) => {
        const isSubSubOpen =
          catsOpen?.subSubCategories === subSubCat?.code;

        return (
          <React.Fragment key={subSubCatIndex}>
            <Button
              sx={{
                fontSize: { xs: ".9rem", lg: "1.1rem" },
                justifyContent: "space-between",
                alignItems: "center",
                px: { xs: ".5rem", lg: "2.3rem" },
                bgcolor: theme.palette.background.lightCream,
                width: "100%",
                mt: ".2rem",
              }}
              onClick={() => {
                setCatsOpen(
                  !isSubSubOpen
                    ? { ...catsOpen, subSubCategories: subSubCat?.code }
                    : { ...catsOpen, subSubCategories: false }
                );

                handleQuery(
                  "category",
                  !isSubSubOpen ? subSubCat?.code : ""
                );
              }}
            >
              <Stack
                direction="row"
                alignItems="center"
                sx={{
                  fontSize: ".9rem",
                  color: theme.palette.primary.low,
                }}
              >
                <Checkbox
                  checked={
                    query?.category === subSubCat?.code &&
                    isSubSubOpen
                  }
                  sx={{ color: theme.palette.primary.low }}
                />
                {subSubCat?.name}
              </Stack>
            </Button>
          </React.Fragment>
        );
      });

      return (
        <React.Fragment key={subCatIndex}>
          <Button
            color="secondary"
            sx={{
              fontSize: { xs: ".9rem", lg: "1.1rem" },
              justifyContent: "space-between",
              alignItems: "center",
              px: { xs: ".5rem", lg: "1.5rem" },
              position: "relative",
              width: "100%",
              mt: ".2rem",
            }}
            onClick={() => {
              setCatsOpen(
                !isSubOpen
                  ? { ...catsOpen, subCategories: subCat?.code }
                  : { ...catsOpen, subCategories: false }
              );
              handleQuery("category", !isSubOpen ? subCat?.code : "");
            }}
          >
            <Stack
              direction="row"
              alignItems="center"
              sx={{
                color: theme.palette.primary.light,
                fontSize: ".9rem",
              }}
            >
              <Checkbox
                checked={
                  query?.category === subCat?.code && isSubOpen
                }
                sx={{ color: theme.palette.primary.light }}
              />
              {subCat?.name}
            </Stack>

            <ArrowLeftIcon
              sx={{
                fontSize: "2.5rem",
                transition: "all .2s",
                color: theme.palette.primary.light,
                transform: isSubOpen ? "rotate(-90deg)" : "",
              }}
            />

            <GradientBorderBox
              bgGrad={`linear-gradient(
                270deg,
                ${theme.palette.background.default} -80%,
                ${theme.palette.background.paper} 50%,
                ${theme.palette.primary.light} 130%
              )`}
              radius=".2rem"
              inside
            />
          </Button>

          <Collapse in={isSubOpen} timeout={300}>
            {subSubItems}
          </Collapse>
        </React.Fragment>
      );
    });

    return (
      <React.Fragment key={mainCatIndex}>
        <Button
          color="secondary"
          sx={{
            fontSize: { xs: ".9rem", lg: "1.1rem" },
            justifyContent: "space-between",
            alignItems: "center",
            px: { xs: ".5rem", lg: ".5rem" },
            width: "100%",
            mt: ".2rem",
            position: "relative",
          }}
          onClick={() => {
            setCatsOpen(
              !isMainOpen
                ? { ...catsOpen, mainCategories: mainCat?.code }
                : { ...catsOpen, mainCategories: false }
            );
            handleQuery("category", !isMainOpen ? mainCat?.code : "");
          }}
        >
          <Stack
            direction="row"
            alignItems="center"
            sx={{
              color: theme.palette.primary.main,
              fontSize: ".95rem",
            }}
          >
            <Checkbox
              checked={
                query?.category === mainCat?.code && isMainOpen
              }
              sx={{ color: theme.palette.primary.main }}
            />
            {mainCat?.name}
          </Stack>

          <ArrowLeftIcon
            sx={{
              fontSize: "2.5rem",
              transition: "all .2s",
              color: theme.palette.primary.main,
              transform: isMainOpen ? "rotate(-90deg)" : "",
            }}
          />

          <GradientBorderBox radius=".2rem" inside />
        </Button>

        <Collapse in={isMainOpen} timeout={400}>
          {subItems}
        </Collapse>
      </React.Fragment>
    );
  });

  return <>{items}</>;
}
